import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  retry,
} from '@reduxjs/toolkit/query/react'
import { toast } from 'react-toastify'
import { Mutex } from 'async-mutex'
import { getAccessToken } from '@privy-io/react-auth'

const mutex = new Mutex()

const baseQuery = retry(
  fetchBaseQuery({
    baseUrl: process.env.baseUrl,
    credentials: 'include',
    timeout: 60000,
    prepareHeaders: async (headers) => {
      // ---------- PRIVY --------------
      const token = await getAccessToken()

      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
        return headers
      } else {
        console.error('No user logged in or unable to get token')
      }
      return headers
    },
  }),
  {
    maxRetries: 2,
  },
)

const BaseQueryWithReAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  await mutex.waitForUnlock()

  let result = await baseQuery(args, api, extraOptions)
  if (!result.error) return result

  switch (result.error.status) {
    case 401:
      if (!mutex.isLocked()) {
        const release = await mutex.acquire()
        try {
          // refresh token
          // const token = await auth.currentUser?.getIdToken(true)
          // store.dispatch(authActions.setUser(''))
          window.location.href = '/sign-in'
        } finally {
          release()
        }
      } else {
        await mutex.waitForUnlock()
        result = await baseQuery(args, api, extraOptions)
      }
      break

    case 403:
      if (!mutex.isLocked()) {
        const release = await mutex.acquire()
        try {
          // store.dispatch(authActions.setUser(''))
          window.location.href = '/sign-in'
          toast.error('User is blocked!')
        } finally {
          release()
        }
      } else {
        await mutex.waitForUnlock()
        result = await baseQuery(args, api, extraOptions)
      }
      break
    default:
      console.log(result.error)
      break
  }

  return result
}

export const baseApi = createApi({
  baseQuery: BaseQueryWithReAuth,
  endpoints: () => ({}),
  tagTypes: ['Feed', 'Comment'],
})
